<template>
  <div class="foods">
    <main-app-bar>
      <template v-slot:title> Food Swaps </template>

      <template v-slot:actions>
        <v-btn
          class="bg-primary-gradient primary ml-auto"
          @click="$router.push({ name: 'form.food-swap' })"
          depressed
        >
          <v-icon class="mr-2"> {{ icons.add }} </v-icon>
          Add Food Swap
        </v-btn>
      </template>
    </main-app-bar>

    <div class="mt-5 px-12 mb-10">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import MainAppBar from '@/layouts/shared/MainAppBar'
import { mdiPlus } from '@mdi/js'

export default {
  name: 'FoodPage',

  components: {
    MainAppBar,
  },

  data() {
    return {
      addNew: false,
      icons: {
        add: mdiPlus,
      },
    }
  },
}
</script>
